const useRecaptcha = () => {
  const execute = async (action) => {
    if (
      !window.grecaptcha ||
      !process.env.REACT_APP_RECAPTCHA_SITE_KEY
    ) {
      return null;
    }

    return new Promise((resolve) => {
      window.grecaptcha.ready(async () => {
        const token = await window.grecaptcha.execute(
          process.env.REACT_APP_RECAPTCHA_SITE_KEY,
          { action }
        );
        resolve(token);
      });
    });
  };

  return { execute };
};

export default useRecaptcha;
